/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_StartInputs */

const cs_settings_profile_2fa_start = /** @type {(inputs: Settings_Profile_2fa_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapnout autentikátor`)
};

const en_settings_profile_2fa_start = /** @type {(inputs: Settings_Profile_2fa_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable authenticator`)
};

/**
* | output |
* | --- |
* | "Enable authenticator" |
*
* @param {Settings_Profile_2fa_StartInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_start = /** @type {((inputs?: Settings_Profile_2fa_StartInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_StartInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_start(inputs)
	return cs_settings_profile_2fa_start(inputs)
});